import { render, staticRenderFns } from "./BorderBox15.vue?vue&type=template&id=3007a9be&scoped=true"
import script from "./BorderBox15.vue?vue&type=script&lang=js"
export * from "./BorderBox15.vue?vue&type=script&lang=js"
import style0 from "./BorderBox15.vue?vue&type=style&index=0&id=3007a9be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3007a9be",
  null
  
)

export default component.exports